import {
  DEVICE_CPU_INDICATOR,
  DEVICE_DC_FS_TYPE_INDICATOR,
  DEVICE_DISK_SPACE_INDICATOR,
  DEVICE_DISK_TYPE_INDICATOR,
  DEVICE_EVENING_PEAK_RATE_INDICATOR,
  DEVICE_FS_TYPE_INDICATOR,
  DEVICE_IPV6_INDICATOR,
  DEVICE_MEM_INDICATOR,
  DEVICE_NAT_INDICATOR,
  DEVICE_NAT_STABLE_TYPE_INDICATOR,
  DEVICE_ONLINE_TIME_INDICATOR,
  DEVICE_PING_LOST_INDICATOR,
  DEVICE_PING_RTT_INDICATOR,
  DEVICE_UPNP_INDICATOR,
} from './device';

// 诊断等级——正常
export const INDICATOR_NORMAL_STATUS = 'normal';
// 诊断等级——异常
export const INDICATOR_ABNORMAL_STATUS = 'abnormal';
// 诊断等级——可优化
export const INDICATOR_OPTIMIZE_STATUS = 'optimize';

// 多线路图表页需要展示每条线路提示文案的状态
export const SHOW_LINE_CHART_TIPS_STATUS = [INDICATOR_ABNORMAL_STATUS, INDICATOR_OPTIMIZE_STATUS];

export const INDICATOR_MODULE_INFO = {
  online: {
    title: '在线情况',
  },
  networkQuality: {
    title: '网络质量',
  },
  nat: {
    title: '网络NAT',
  },
  deviceProperty: {
    title: '设备性能',
  },
  diskDetail: {
    title: '硬盘',
  },
  [DEVICE_ONLINE_TIME_INDICATOR]: {
    title: '在线时长',
    // 单位
    unitText: '（小时）',
    indicatorContent: '网络在线指设备全天网络在线，越大越优，请保持全天正常在线',
  },
  [DEVICE_EVENING_PEAK_RATE_INDICATOR]: {
    title: '晚高峰在线率',
    unitText: '（百分比）',
    indicatorContent:
      '晚高峰在线率是指高峰期（18-24点）设备在线时长占比，越大越优，请保持全天正常在线',
  },
  [DEVICE_PING_LOST_INDICATOR]: {
    title: '设备丢包率',
    unitText: '（百分比）',
    indicatorContent:
      '丢包是指设备数据由于某种原因被丟弃，常见于晚高峰网络拥塞等情况。请检查上行带宽是否饱和，建议增加上行带宽或优化路由器/光猫性能，以提高网络质量；',
  },
  [DEVICE_PING_RTT_INDICATOR]: {
    title: '设备时延',
    unitText: '（毫秒）',
    indicatorContent:
      '时延是指设备传输数据所需的时间，延时过大常见于晚高峰网络拥塞。请检查上行带宽是否饱和，建议增加上行带宽或优化路由器/光猫性能，以提高网络质量；',
  },
  [DEVICE_NAT_INDICATOR]: {
    title: '管理线路NAT',
    unitText: '',
    indicatorContent:
      '线路NAT的不同等级对应网络质量不同，NAT类型差将严重影响跑量效果。类型排名：卓越公网>DMZ公网>映射公网>全锥>IP限制>端口限制>对称型。建议优化拨号方式，或路由器开启DMZ/UPNP（二选其一）以达到更优NAT。',
  },
  [DEVICE_UPNP_INDICATOR]: {
    title: 'UPNP',
    indicatorContent:
      'UPNP是端口映射的一种方法，通过调整路由器UPNP可改善网络NAT类型，建议开启路由器UPNP或DMZ（二选其一）。若NAT类型已优化至全锥型及以上，则可以忽略。',
  },
  [DEVICE_NAT_STABLE_TYPE_INDICATOR]: {
    title: '稳定性',
    indicatorContent:
      '稳定性是指NAT类型探测结果的稳定性，计算为当天NAT的变化情况。若NAT不稳定，建议增加上行带宽或优化路由器/光猫性能。',
  },
  [DEVICE_CPU_INDICATOR]: {
    title: 'CPU性能',
    indicatorContent: 'CPU性能是指设备CPU核数*CPU频率，CPU性能越高越优',
  },
  [DEVICE_MEM_INDICATOR]: {
    title: '内存',
    unitText: '（Gbyte）',
    indicatorContent: '内存是指分配给设备的随机存储内存，空间越大越优',
  },
  [DEVICE_IPV6_INDICATOR]: {
    title: 'IPv6',
    indicatorContent:
      'IPv6情况是指设备是否具备IPv6全球单播地址及其连通性。特殊业务放量将优先调度至具有IPv6地址的网心云设备（待连通），推荐设备配置IPv6为已连通状态；',
  },
  [DEVICE_DISK_SPACE_INDICATOR]: {
    title: '磁盘缓存',
    unitText: '（G）',
    indicatorContent:
      '磁盘缓存是指硬盘的存储空间，越大越优，请检查硬盘容量情况，建议使用容量更大的硬盘',
  },
  [DEVICE_DISK_TYPE_INDICATOR]: {
    title: '磁盘类型',
    indicatorContent: '磁盘类型是指设备存储数据时使用的介质类型，建议使用SSD固态硬盘。',
  },
  [DEVICE_FS_TYPE_INDICATOR]: {
    title: '文件系统',
    indicatorContent: `<p>
    文件系统是指管理磁盘空间的文件系统类型，建议采用裸盘。非裸盘设备可通过【APP-设备详情-升级裸盘】进行升级或提供批量SN联系客服处理。
    <br />* 裸盘——整块磁盘做成LVM（逻辑卷管理）
    <br />* EXT4——第四代扩展文件系统，Linux系统下的日志文件系统
    <br />* NTFS——WindowsNT 环境的文件系统
  </p>`,
  },
  [DEVICE_DC_FS_TYPE_INDICATOR]: {
    title: '文件系统',
    indicatorContent: `<p>
    文件系统是指管理磁盘空间的文件系统类型，建议采用XFS/BTRFS/EXT4；
    <br />* XFS——一种高性能的日志文件系统
    <br />* BTRFS——Butter FS，针对Linux开发的一个新的CoW（copy-on-write,写时复制）文件系统
    <br />* EXT4——第四代扩展文件系统，Linux系统下的日志文件系统
    <br />* NTFS——WindowsNT 环境的文件系统
  </p>`,
  },
};

// 线路数据提示名称
export const DEVICE_INDICATOR_LINE_TITLE = {
  [DEVICE_PING_LOST_INDICATOR]: '丢包率',
  [DEVICE_PING_RTT_INDICATOR]: '时延',
  [DEVICE_NAT_INDICATOR]: 'NAT',
};

// 硬盘
export const DISK_DETAIL_MODULE = 'diskDetail';

// 默认诊断模块与指标映射关系
export const DEFAULT_INDICATOR_IN_MODULE = {
  [DISK_DETAIL_MODULE]: [
    DEVICE_DISK_SPACE_INDICATOR,
    DEVICE_DISK_TYPE_INDICATOR,
    DEVICE_FS_TYPE_INDICATOR,
  ],
};

export const DEFAULT_DC_INDICATOR_IN_MODULE = {
  [DISK_DETAIL_MODULE]: [
    DEVICE_DISK_SPACE_INDICATOR,
    DEVICE_DISK_TYPE_INDICATOR,
    DEVICE_DC_FS_TYPE_INDICATOR,
  ],
};

// 设备诊断结果文案
export const DEVICE_DIAGNOSIS_RES_TEXT = {
  [INDICATOR_NORMAL_STATUS]: {
    label: '正常',
    desc: '当前设备运行正常，请继续保持全天在线！',
  },
  [INDICATOR_ABNORMAL_STATUS]: {
    label: '异常',
    desc: '昨日设备出现异常问题，导致收益不理想，请尽快解决！',
  },
  [INDICATOR_OPTIMIZE_STATUS]: {
    label: '正常',
    desc:
      '当前设备运行正常，可能因业务波动或正处于业务部署期，导致收益不理想，请保持设备全天在线，收益将逐步稳定！',
  },
};

export const INDICATOR_PAGE_NAME = 'indicator';

export const INDICATOR_CHART_INFO = {
  [DEVICE_ONLINE_TIME_INDICATOR]: {
    title: '在线时长',
    deviceChartTitle: '近7天全天在线时长',
    standard: '建议23.5h以上',
    yAxisName: '时长',
    unit: '(h)',
  },
  [DEVICE_PING_LOST_INDICATOR]: {
    title: '设备丢包率',
    deviceChartTitle: '近7天线路平均丢包率',
    lineChartTitle: '近7天丢包率',
    standard: '建议低于2%',
    yAxisName: '丢包率',
    unit: '(%)',
  },
  [DEVICE_PING_RTT_INDICATOR]: {
    title: '设备时延',
    deviceChartTitle: '近7天线路平均时延',
    lineChartTitle: '近7天时延',
    standard: '建议低于20ms',
    yAxisName: '时延',
    unit: '(ms)',
  },
  [DEVICE_NAT_INDICATOR]: {
    title: '网络NAT',
    deviceChartTitle: '近7天管理线路NAT',
    lineChartTitle: '近7天NAT类型',
    standard: '建议全锥型及以上',
    yAxisName: 'NAT类型',
    unit: '',
  },
  [DEVICE_CPU_INDICATOR]: {
    title: 'CPU性能',
    deviceChartTitle: '近7天CPU占用率',
    standard: '建议90%以下',
    yAxisName: 'CPU占用率',
    unit: '(%)',
  },
  [DEVICE_MEM_INDICATOR]: {
    title: '内存',
    deviceChartTitle: '近7天内存占用率',
    lineChartTitle: '',
    standard: '建议90%以下',
    yAxisName: '内存占用率',
    unit: '(%)',
  },
};

// 统计等级
export const GRADE_TO_STATISTICS = ['optimize', 'abnormal'];

// 线路tab
export const INDICATOR_CHART_LINE_TAB = 'line';
// 设备tab
export const INDICATOR_CHART_DEVICE_TAB = 'device';
// tab对应文案
export const INDICATOR_CHART_TAB_TEXT = {
  [INDICATOR_CHART_DEVICE_TAB]: '设备',
  [INDICATOR_CHART_LINE_TAB]: '线路',
};

// 多线路指标
export const MULTI_LINE_INDICATORS = [
  DEVICE_PING_RTT_INDICATOR,
  DEVICE_PING_LOST_INDICATOR,
  DEVICE_NAT_INDICATOR,
];

export const INDICATOR_CHART_PAGE_NAME = 'indicator_chart';
// 多线路最大展示条数
export const INDICATOR_CHART_MAX_NUM = 10;

export const INDICATOR_TIME_FORMAT = 'YYYY-MM-DD';
